
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Mumbaiairporttonashiktaxi() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Nashik Taxi  ',
        heading: 'Morya Cabs: Mumbai Airport to Nashik Taxi ',
        headingDescription: 'Morya Cabs offers a seamless and comfortable taxi service from Mumbai Airport to Nashik, catering to both leisure and business travelers. Whether you are heading to Nashik for a religious visit, a wine-tasting tour, or a weekend getaway, we ensure a safe, hassle-free, and comfortable ride. The distance from Mumbai Airport to Nashik is approximately 170 km, and the journey typically takes around 3.5 to 4 hours. With Morya Cabs, you can be assured of punctuality, comfort, and a relaxing experience on the road.',

        top: 'Top Places to Visit in Nashik with Morya Cabs',

"topPlaces": [
    {
        "title": "Trimbakeshwar Temple",
        "location": "Trimbak, near Nashik, Maharashtra",
        "description": "Trimbakeshwar Temple, located in Trimbak near Nashik, is one of the twelve Jyotirlingas of Lord Shiva and holds great religious significance. The temple, surrounded by lush hills, is a must-visit pilgrimage site for devotees of Lord Shiva."
    },
    {
        "title": "Saptashrungi",
        "location": "Near Nashik, Maharashtra",
        "description": "Saptashrungi is a sacred hill located about 60 km from Nashik and is home to the Saptashrungi Mata Temple, one of the 51 Shakti Peethas. A trek to the top of the hill offers breathtaking views of the surrounding hills and valleys."
    },
    {
        "title": "Pandav Leni Caves",
        "location": "Trimbakeshwar Road, Nashik, Maharashtra",
        "description": "Pandav Leni is a group of ancient Buddhist caves that date back to around the 1st century BCE. Located on the Trimbakeshwar road, these caves are known for their beautiful carvings, inscriptions, and peaceful ambiance, making them an excellent spot for history and architecture enthusiasts."
    },
    {
        "title": "Kalaram Sansthan Temple",
        "location": "Nashik, Maharashtra",
        "description": "Dedicated to Lord Rama, Kalaram Sansthan Temple in Nashik is an ancient and important temple, famous for its black stone idol of Lord Rama. The temple is an essential stop for those seeking spiritual solace and tranquility."
    },
    {
        "title": "Godavari River and Panchavati",
        "location": "Nashik, Maharashtra",
        "description": "The Godavari River, one of India's most sacred rivers, flows through Nashik. Panchavati, located near the river, is home to various temples and ghats. It is believed that Lord Rama, during his exile, stayed here, making it a significant religious spot for devotees."
    },
    {
        "title": "Nashik Vineyards",
        "location": "Nashik, Maharashtra",
        "description": "Nashik is renowned as the 'Wine Capital of India,' and visitors can explore its vineyards to enjoy wine-tasting tours and learn about the wine-making process. Popular wineries include Sula Vineyards, York Winery, and Vinsura Winery."
    },
    {
        "title": "Anjneri Hill",
        "location": "Near Nashik, Maharashtra",
        "description": "Anjneri Hill, located near Nashik, is believed to be the birthplace of Lord Hanuman. It is a popular pilgrimage and trekking destination, offering panoramic views of the surrounding region and the peaceful atmosphere of the Hanuman Temple located atop the hill."
    },
    {
        "title": "Ganga Ghat",
        "location": "Nashik, Maharashtra",
        "description": "Ganga Ghat, located near the Godavari River, is one of the most revered ghats in Nashik, where pilgrims come to take a holy dip in the river. It is also associated with the Kumbh Mela, a major Hindu festival that is held in Nashik every twelve years."
    },
    {
        "title": "Brahmagiri Hill",
        "location": "Near Trimbakeshwar, Maharashtra",
        "description": "Brahmagiri Hill, located near Trimbakeshwar, is known for its connection to Lord Vishnu and offers a peaceful trekking experience with stunning views of the valley below. It is an ideal spot for nature lovers and those seeking spiritual reflection."
    },
    {
        "title": "Nashik Fort (Nashik Killa)",
        "location": "Nashik, Maharashtra",
        "description": "Nashik Fort, also known as Nashik Killa, is a historical fort located in the heart of the city. The fort has an interesting history, offering a glimpse into the Maratha Empire and provides panoramic views of the surrounding area. It’s a great spot for history lovers and tourists interested in exploring Nashik’s rich cultural heritage."
    }
],


"services": [
    {
        "name": "Mumbai Airport to Nashik Taxi Service",
        "description": "For a comfortable and convenient ride from Mumbai Airport to Nashik, book your taxi with Morya Cab. Our experienced drivers ensure a smooth journey with timely pickups and professional service."
    },
    {
        "name": "Mumbai Airport to Nashik Cab Service",
        "description": "Choose Morya Cab for taxi services from Mumbai Airport to Nashik. We offer a wide range of vehicles and ensure a comfortable and stress-free trip."
    },
    {
        "name": "Mumbai Airport to Nashik Taxi Fare",
        "description": "Our Mumbai Airport to Nashik taxi fare is competitive and transparent, with no hidden costs. You’ll get an upfront quote when you book your taxi."
    },
    {
        "name": "Mumbai Airport to Nashik One Way Taxi",
        "description": "Need a one-way taxi from Mumbai Airport to Nashik? Morya Cab offers flexible one-way taxi services, ensuring an affordable and hassle-free ride."
    },
    {
        "name": "Mumbai Airport to Nashik Innova",
        "description": "For a spacious and comfortable ride, book an Innova from Mumbai Airport to Nashik. It’s perfect for families or small groups who want a smooth journey with ample space."
    },
    {
        "name": "Mumbai Airport to Nashik Ertiga",
        "description": "For a more budget-friendly yet comfortable option, choose the Ertiga for your Mumbai Airport to Nashik journey. The Ertiga offers enough space for small groups and ensures a pleasant ride."
    },
    {
        "name": "Mumbai Airport to Nashik Sedan",
        "description": "Our sedan taxis are ideal for solo travelers or couples, providing comfort and privacy during your ride from Mumbai Airport to Nashik."
    },
    {
        "name": "Mumbai Airport to Nashik Taxi Booking",
        "description": "Booking your Mumbai Airport to Nashik taxi is easy with Morya Cab. Simply book online, or call our customer support team for a quick and seamless booking experience."
    },
    {
        "name": "Taxi Service from Mumbai Airport to Nashik",
        "description": "Morya Cab offers reliable taxi services from Mumbai Airport to Nashik, ensuring a safe and comfortable trip. Book your taxi today and enjoy a stress-free ride to your destination."
    },
    {
        "name": "Mumbai to Nashik Airport Taxi",
        "description": "Whether you’re arriving at Mumbai Airport or heading there, Morya Cab provides airport taxi services for your journey from Mumbai to Nashik. We guarantee prompt service and professional drivers."
    },
    {
        "name": "Mumbai Airport to Nashik by Cab",
        "description": "Travel in comfort from Mumbai Airport to Nashik with Morya Cab. We ensure a smooth and relaxing ride with well-maintained vehicles and professional drivers."
    },
    {
        "name": "Nashik Trip from Mumbai Airport",
        "description": "Planning a trip to Nashik from Mumbai Airport? Book your Morya Cab today, and enjoy an effortless journey to the religious and scenic beauty of Nashik."
    },
    {
        "name": "Mumbai Airport to Nashik Drop Taxi",
        "description": "If you just need a drop taxi from Mumbai Airport to Nashik, Morya Cab offers quick, affordable, and reliable services with no hidden charges."
    },
    {
        "name": "Mumbai Airport Taxi Booking",
        "description": "Morya Cab offers easy taxi booking for all your travel needs, including rides from Mumbai Airport to Nashik. Book your taxi now for a safe and comfortable journey."
    },
    {
        "name": "Mumbai to Nashik Car Hire",
        "description": "For more flexibility, choose Morya Cab’s car hire services for your journey from Mumbai to Nashik. Hire a car with a professional driver, and travel at your own pace."
    },
    {
        "name": "Contact Morya Cab for Your Mumbai Airport to Nashik Taxi Booking",
        "description": "Call us at +91 9371304510 or visit our website for seamless booking and prompt service."
    }
],


tableData: [
    ["Mumbai Airport to Nashik Taxi", "-Mumbai Airport to Nashik Cab Service"],
    ["Mumbai Airport to Nashik Taxi Fare", "-Mumbai Airport to Nashik One Way Taxi"],
    ["Mumbai Airport to Nashik Innova", "-Mumbai Airport to Nashik Ertiga"],
    ["Mumbai Airport to Nashik Sedan", "-Mumbai Airport to Nashik Taxi Booking"],
    ["Taxi Service from Mumbai Airport to Nashik", "-Mumbai to Nashik Airport Taxi"],
    ["Mumbai Airport to Nashik by Cab", "-Nashik Trip from Mumbai Airport"],
    ["Mumbai Airport to Nashik Drop Taxi", "-Mumbai Airport Taxi Booking"],
    ["Mumbai to Nashik Car Hire", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we understand the importance of time, especially when traveling from Mumbai Airport to Nashik. Our experienced drivers ensure punctual pickups from the airport and timely arrivals, so you can start your journey stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer comfortable and well-maintained vehicles for your journey from Mumbai Airport to Nashik. With spacious interiors, air conditioning, and comfortable seating, you'll enjoy a smooth and relaxing ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced in navigating the route from Mumbai Airport to Nashik. They ensure that your trip is safe, efficient, and comfortable while following all traffic regulations and road safety protocols."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab provides affordable taxi services with no hidden charges. Our pricing is transparent, so you know exactly what to expect, ensuring you get great value for your money without any surprises."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All of our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers strictly adhere to safety standards for a worry-free journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you're arriving at Mumbai Airport early in the morning or late at night, Morya Cab is available 24/7 to cater to your needs. Our customer service team is always ready to assist you in booking a taxi at any time."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your taxi from Mumbai Airport to Nashik is easy. You can book online via our website or mobile app, or simply contact our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer flexible and customized travel packages. If you need to make stops along the way or require any specific services, just let us know, and we’ll tailor the trip to meet your requirements."
    }
]













    }

    const faqData = [
        {
          question: "How can I book a Mumbai Airport to Nashik taxi with Morya Cab?",
          answer: "You can book a taxi easily through our website or mobile app. Alternatively, our customer service team is available to assist you with your booking."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, our drivers are experienced in long-distance travel, including the route from Mumbai Airport to Nashik. They ensure a safe, smooth, and timely journey."
        },
        {
          question: "What types of vehicles are available for Mumbai Airport to Nashik travel?",
          answer: "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars. All our vehicles are designed for comfort and equipped with modern amenities."
        },
        {
          question: "How do I pay for my Mumbai Airport to Nashik taxi rental?",
          answer: "We accept various payment options including cash, credit/debit cards, and online payments via our app for your convenience."
        },
        {
          question: "Can I book a round trip from Mumbai Airport to Nashik?",
          answer: "Yes, you can book a round-trip taxi. Just provide your return details at the time of booking, and we’ll make sure everything is taken care of for your return journey."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges for waiting or detours will be communicated to you upfront, ensuring complete transparency in our pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing in Nashik?",
          answer: "Yes, we offer sightseeing tours in Nashik. You can visit famous attractions like the Trimbakeshwar Temple, Saptashrungi Fort, and Kalaram Sansthan with a professional driver."
        },
        {
          question: "What is the luggage allowance for a Mumbai Airport to Nashik taxi?",
          answer: "Our vehicles can accommodate standard luggage. If you have extra luggage or specific requirements, please inform us at the time of booking, and we will make necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel from Mumbai Airport to Nashik?",
          answer: "Yes, we offer corporate travel services. Whether it's for business meetings or team events, we can provide customized travel packages to suit your company’s needs."
        },
        {
          question: "Why should I choose Morya Cab for Mumbai Airport to Nashik travel?",
          answer: "Morya Cab is known for its reliable service, experienced drivers, affordable rates, and well-maintained vehicles. We ensure a comfortable, safe, and efficient journey for all your travel needs."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Arvind Mehta',
          role: 'Business Traveler',
          review: 'My flight landed late, but Morya Cab was there right on time to pick me up from Mumbai Airport. The driver was professional and made sure I had a smooth ride to Nashik. Highly recommend their services!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Priya Desai',
          role: 'Leisure Traveler',
          review: 'I used Morya Cab for a trip from Mumbai Airport to Nashik, and it was a great experience. The vehicle was clean, and the driver was courteous. I felt safe and comfortable the entire journey.',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Morya Cab Services",
        "description": "Book your Mumbai Airport to Nashik taxi with Morya Cab. Affordable, reliable one-way taxis, drop-off services, and more! Call +91 9371304510 for bookings!",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, First Floor, Sunshine Complex, Near ABC Chowk, Pune",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-9371304510",
        "url": "https://moryacab.com/",
        "logo": "https://moryacab.com/img/logo.jpg",
        "image": [
          "https://moryacab.com/img/mumbai-to-nashik-taxi.jpg",
          "https://moryacab.com/img/mumbai-to-nashik-cab-service.jpg"
        ],
        "priceRange": "₹2000 - ₹3500",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/mumbai-airport-to-nashik-taxi-service",
          "priceCurrency": "INR",
          "price": 3000,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.6,
          "reviewCount": 150
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi Kumar"
            },
            "datePublished": "2024-04-18",
            "reviewBody": "The taxi from Mumbai Airport to Nashik was excellent. The driver was on time, and the vehicle was very comfortable. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sita Verma"
            },
            "datePublished": "2024-07-20",
            "reviewBody": "Great experience with Morya Cab. The taxi was clean and the ride was smooth. I will definitely use this service again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai Airport to Nashik Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 19.9975,
            "longitude": 73.7874
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/mumbai-airport-to-nashik-taxi-service"
        },
        "keywords": "mumbai airport to nashik taxi, mumbai airport to nashik cab service, mumbai airport to nashik taxi fare, mumbai airport to nashik one way taxi, mumbai airport to nashik innova, mumbai airport to nashik ertiga, mumbai airport to nashik sedan, mumbai airport to nashik taxi booking, taxi service from mumbai airport to nashik, mumbai to nashik airport taxi, mumbai airport to nashik by cab, nashik trip from mumbai airport, mumbai airport to nashik drop taxi, mumbai airport taxi booking, mumbai to nashik car hire"
      };


    return (
        <div>
            <UsePageTracking/>
    <Helmet>
        <title>Mumbai Airport to Nashik Taxi | Affordable & Reliable Cab Services | Call: +91 9371304510</title>
        <meta
          name="description"
          content="Book your Mumbai Airport to Nashik taxi with Morya Cab. Affordable, reliable one-way taxis, drop-off services, and more! Call +91 9371304510."
        />
        <meta name="keywords" content="mumbai airport to nashik taxi, cab services, taxi booking, affordable taxi" />
        <meta property="og:title" content="Mumbai Airport to Nashik Taxi | Morya Cab Services" />
        <meta property="og:description" content="Book your Mumbai Airport to Nashik taxi with Morya Cab. Affordable, reliable one-way taxis, drop-off services, and more!" />
        <meta property="og:url" content="https://moryacab.com/mumbai-airport-to-nashik-taxi-service" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://moryacab.com/img/mumbai-to-nashik-taxi.jpg" />
        <script type="application/ld+json">
          {JSON.stringify(jsonLD)}
        </script>
      </Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #1CA8CB',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaiairporttonashiktaxi;